import { ReactNode } from "react";
import { Col, Container, Row } from "react-bootstrap";

export interface MediumPageProps {
    children: ReactNode;
}

export function MediumPage( props: MediumPageProps ) {
    return <Container fluid>
        <Row className="justify-content-left">
            <Col md={11} lg={10} xl={9} xxl={8}>
                {props.children}
            </Col>
        </Row>
    </Container>;
}